export default __webpack_public_path__ + "static/media/backcover.8e157ca2.png";